import { jsx as _jsx } from "react/jsx-runtime";
import { LoadingPopUpView } from '../../Components/PopUps/LoadingPopUpView';
export function LoadingScreenView(_) {
    return _jsx(LoadingPopUpView, { visible: true });
}
